interface RegExpressionProps {
  [key: string]: RegExp;
}

const regExpression: RegExpressionProps = {
  email: /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/,
};

export default regExpression;

export const SEARCH_QUERY_WHITELIST = /[^\w-'&.èÓ ]/g;
export const SEARCH_QUERY_WHITELIST_DP = /[^\w'&.èÓ ]/g;

export const MULTIPLE_WHITE_SPACES = /  +/g;

export const MOBILE_NUMBER_REGEX = /^[6-9]([0-9]{9})$/;
